// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"9f4c1f0c","202":"144a5c6a","551":"115a8e0d","556":"e2f0e78e","565":"2fdc53b6","811":"c9650e0b","901":"144a5c6a","929":"bd591350"}[chunkId] + ".chunk.css";
};